import { settlementAmountInfo } from '@root/state/reducers/Settlement/settlementReducer';
import { Col, Form, Row } from 'antd';
import '../../../../styles/pages/warehouse/_settlement/index.scss';

const TransactionAmount = ({
  amountInfo
}: {
  amountInfo: settlementAmountInfo;
}) => {
  return (
    <div className="totalSettlement">
      <Row>
        <Col span={14}>
          <Form.Item>
            <p>Total Transaction Amount</p>
            <h1>
              $
              {(amountInfo?.totalAmount).toLocaleString('en-US', {
                minimumFractionDigits: 2
              })}
            </h1>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            <p>Monthly Amount</p>
            <h1>
              $
              {amountInfo?.monthlyAmount.toLocaleString('en-US', {
                minimumFractionDigits: 2
              })}
            </h1>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            <p>Balance</p>
            <h1>
              $
              {amountInfo?.balanceAmount.toLocaleString('en-US', {
                minimumFractionDigits: 2
              })}
            </h1>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default TransactionAmount;
